import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { CuentasPorCobrarService } from '../../../services/cuentas-por-cobrar.service';
import { ConstantsService } from '../../../services/constants.service';
import { CatalogosSatService } from '../../../services/catalogos-sat-service';

@Component({
  selector: 'app-modal-listado-facturas-pago',
  templateUrl: './modal-listado-facturas-pago.component.html',
  styleUrls: ['./modal-listado-facturas-pago.component.scss']
})
export class ModalListadoFacturasPago implements OnInit {
    @ViewChild('content') private content: TemplateRef<any>;
    

    //Modelos
    public cuentaPorCobrar: any = [];
    public pagos: any = [];

    //Helpers
    public modal: any = null;
    public api_url: any = "";
    public errors: any = {};
    public loading: boolean = false;

    constructor(public cuentas_por_cobrar_service:CuentasPorCobrarService, 
        private constant: ConstantsService, 
        private modalService: NgbModal,
        private satService: CatalogosSatService) { 
          this.api_url = constant.apiURL;
    }

    public openModal(cuentaPorCobrar: any){
      this.modal = this.modalService.open(this.content, { });
      this.cuentaPorCobrar = cuentaPorCobrar;
      this.obtenerFacturasRecepcionPago();
    }
  
    public closeModal(reloadParent) {
      this.modal.close();
    }
    
    ngOnInit() {     
    }

    private obtenerFacturasRecepcionPago(){
      this.loading = true;
      this.cuentas_por_cobrar_service.listarFacturasRecepcionesPago(this.cuentaPorCobrar.id_cuenta_por_cobrar)
      .subscribe(
        (response)=>{
          this.pagos = response.json().content;  
          this.loading = false;
        },
        (error)=>{
          this.loading = false;
          alert("ERROR:: "+JSON.stringify(error));
        }
      );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/reporte-cxc/modal-listado-facturas-pago/modal-listado-facturas-pago.component.ts